export default __webpack_public_path__ + "static/media/twitterlogo.c426e4bb.svg";